const CANONICAL_BASE = 'https://amakenapp.com'

export default {
    computed: {
      basePath() {
        return this.$route.path.replace(/^\/(en|ar)/, '')
      },
      canonicalUrl() {
        const path = (this.$route.fullPath && this.$route.fullPath.split('?')[0]) || '/'
        const pathNorm = path === '/' ? '/' : path.replace(/\/+$/, '') || '/'
        return CANONICAL_BASE + pathNorm
      },
      hreflangUrls() {
        return {
          en: `${CANONICAL_BASE}/en${this.basePath === '/' ? '' : this.basePath}`,
          ar: `${CANONICAL_BASE}/ar${this.basePath === '/' ? '' : this.basePath}`
        }
      }
    },

    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.canonicalUrl
          },
          {
            rel: 'alternate',
            hreflang: 'en',
            href: this.hreflangUrls.en
          },
          {
            rel: 'alternate',
            hreflang: 'ar',
            href: this.hreflangUrls.ar
          },
          {
            rel: 'alternate',
            hreflang: 'x-default',
            href: CANONICAL_BASE + '/en'
          }
        ]
      }
    }
}
  